module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/sdgRectangle-c5af2c59a1cd8781504554148112c730.png";